import React from 'react';
import { connect } from 'react-redux';
// import MasterCard from '../../assets/svg/MasterCard';
// import Visa from '../../assets/svg/Visa';
// import Success from '../../assets/svg/Success';

import mastercardicon from '../../assets/images/mastercard.svg';
import visaicon from '../../assets/images/visa.svg';
import deleteIcon from '../../assets/images/delete.svg';
import success from '../../assets/images/success.svg';



import { setDefaultPayment, removePayment } from '../../actions/auth';



class DefaultPaymentInfoItem extends React.Component {

    constructor(props) {
        super(props);

        this.removePayment = this.removePayment.bind(this);
    }

    removePayment() {

        if (confirm('Are you sure you want to remove this card? This cannot be undone.')) {
            this.props.dispatch(removePayment(this.props.token, this.props.card.id, this.props.navigation));
        }
    }

    render() {
        return (
            <div className="profile-info-wrapper" style={{ width: "90%", marginLeft: 7}}
                onClick={() => { this.props.dispatch(setDefaultPayment(this.props.token, this.props.card.id)) }}
            >
                <div className="information-wrapper single">
                    <div className="credit-card-info">
                        <div className="is-default-card">
                        { this.props.card.isDefault ? (
                                <div>
                                    <img src={success} className="success-icon" />
                                </div>
                            ): (
                                <div />
                        )}         
                        </div>
                        <div className="card-card-logo-wrapper">
                            <img src={mastercardicon}  className="credit-card-logo-icon" />
                            <img src={visaicon}  className="credit-card-logo-icon" />
                        </div>
                        <div className="card-info-wrapper">
                            {this.props.card.name}
                        </div>
                        <div onClick={this.removePayment}>
                            <img src={deleteIcon} className="trash-can"/>
                        </div>
                    </div>
                </div>
            </div>
               
        );
    }
}

const mapStateToProps = (state) => {

    return {
        user: state.auth.user,
        token: state.auth.token
    };
};

export default connect(mapStateToProps)(DefaultPaymentInfoItem);